import { render, staticRenderFns } from "./DisplayLayout.vue?vue&type=template&id=5fda4cbb&"
import script from "./DisplayLayout.vue?vue&type=script&lang=js&"
export * from "./DisplayLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports